<template>
  <div>
    <v-bottom-sheet
      v-model="sheet"
      hide-overlay
      persistent
    >
      <v-sheet
        class="px-3"
        :style="`max-height:${windowHeight/2}px;overflow-y:auto`"
      >
        <address-search v-if="tab === 0" />

        <selected-infos
          v-if="tab===detailsIdx"
          dense
        />
        <map-legend
          v-if="tab === legendIdx"
          dense
        />
        <div style="height:60px" />
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-navigation
      v-model="tab"
      style="z-index:300"
      :color="sheet ? 'primary' : ''"
    >
      <v-btn
        v-if="!config.hideSearchBar"
        style="min-width:120px"
        small
        class="pa-0"
        @click="toggleSheet"
      >
        <span> {{ (config.sectionsLabel && config.sectionsLabel.address) || 'Adresse' }}
        </span><v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn
        v-if="detailsIdx >= 0"
        :disabled="!selected"
        style="min-width:120px"
        small
        class="pa-0"
        @click="toggleSheet"
      >
        <span>{{ (config.sectionsLabel && config.sectionsLabel.selection) || 'Sélection'
        }}</span><v-icon>mdi-selection-marker</v-icon>
      </v-btn>
      <v-btn
        v-if="legendIdx >= 0"
        style="min-width:120px"
        small
        class="pa-0"
        @click="toggleSheet"
      >
        <span>{{ (config.sectionsLabel && config.sectionsLabel.legend) || 'Légende' }}</span><v-icon>mdi-filter</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
import SelectedInfos from './sections/selected-infos.vue'
import MapLegend from './sections/map-legend.vue'
import AddressSearch from './sections/Address.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    SelectedInfos,
    MapLegend,
    AddressSearch
  },
  data () {
    return {
      sheet: true,
      tab: 0
    }
  },
  computed: {
    ...mapState(['selected']),
    ...mapGetters(['config', 'detailsIdx', 'legendIdx'])
  },
  watch: {
    selected (value) {
      if (value) this.tab = this.detailsIdx
      else this.tab = null
      this.sheet = !!value
    },
    tab (newV, oldV) {
      this.sheet = (newV !== null && oldV !== null)
    }
  },
  methods: {
    toggleSheet (e) {
      this.sheet = !this.sheet
    }
  }
}
</script>

<style lang="css" scoped></style>
